// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gW8wj{margin:0 auto}.dRiQj{margin:4px}.eav6k{gap:0px}.oaBx_{text-align:center}.vOXpH{display:flex;flex-direction:column;align-items:center;text-align:center;margin-bottom:20px}.wTuhp{text-align:center;width:85%;margin:0 auto;margin-top:8px}.rIVza{display:flex;flex-direction:column;align-items:center;gap:16px;margin-top:16px}.rIVza .B2rDs{display:flex;flex-direction:column;align-items:center;gap:24px;width:100%;max-width:400px}@media(max-width: 560px){.rIVza .B2rDs{width:100%}}.rIVza .B2rDs .ZK7zm{text-align:center}.rIVza .B2rDs .hsOeq{align-self:center;border-color:#d4d4e0;border-width:1px;width:100%}.rIVza .B2rDs .PvHzi{width:98%;gap:8px;text-align:center}@media(max-width: 560px){.rIVza .B2rDs .PvHzi{width:380px;max-width:100%}.rIVza .B2rDs .PvHzi>div:first-child,.rIVza .B2rDs .PvHzi>div:last-child{display:none}}.rIVza .e25oY{justify-content:center;margin-top:16px}.rIVza .e25oY::before{content:"<<"}.ONpLJ{margin-top:19px;margin-bottom:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileMaxWidth": `560px`,
	"tabletMinWidth": `561px`,
	"tabletMaxWidth": `1024px`,
	"desktopMinWidth": `1025px`,
	"smallScreenMaxWidth": `1400px`,
	"largeScreenMinWidth": `1401px`,
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"otpForm": `gW8wj`,
	"formFields": `dRiQj`,
	"verticalFormFields": `eav6k`,
	"title": `oaBx_`,
	"subtitle": `vOXpH`,
	"floatingMessage": `wTuhp`,
	"footer": `rIVza`,
	"newCodeContent": `B2rDs`,
	"newCodeText": `ZK7zm`,
	"getNewCodeButton": `hsOeq`,
	"separator": `PvHzi`,
	"backButton": `e25oY`,
	"loadingContainer": `ONpLJ`
};
export default ___CSS_LOADER_EXPORT___;
